// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Esnt","colMin":"styles_colMin__2Ub4q"};